import React, { useState, useEffect } from "react";
import config from "../../config";

const base = config.api.baseUrl;

/** First letter of the server's domain, for the generated fallback tile. */
function domainLetter(url) {
  try {
    const host = new URL(url).hostname.replace(/^www\./, "");
    return (host[0] || "?").toUpperCase();
  } catch (_) {
    return (url && url[0] ? url[0] : "?").toUpperCase();
  }
}

/**
 * Icon for an MCP server, with a 3-tier fallback:
 *  1. `hasIcon` → the cached icon our backend serves (MCP-advertised or favicon).
 *  2. if that image fails to load → a generated blue tile.
 *  3. no icon at all → the same generated blue tile (first letter of the domain).
 */
export default function McpServerIcon({ url, hasIcon, iconVersion, size = 22 }) {
  const [failed, setFailed] = useState(false);
  // Reset on iconVersion too, so a new upload re-attempts after a prior failure.
  useEffect(() => { setFailed(false); }, [url, hasIcon, iconVersion]);

  if (hasIcon && !failed) {
    // Append the server-provided version so the browser cache busts exactly
    // when the icon changes (e.g. an admin override) — the URL is otherwise
    // identical and the icon is served with a 1-hour Cache-Control.
    const v = iconVersion ? `&v=${iconVersion}` : "";
    const src = `${base}${config.api.endpoints.claudeAgent.mcpServerIcon}?url=${encodeURIComponent(url)}${v}`;
    return (
      <img
        className="ca-mcp-icon"
        src={src}
        alt=""
        width={size}
        height={size}
        loading="lazy"
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <span
      className="ca-mcp-icon ca-mcp-icon--letter"
      aria-hidden="true"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.55) }}
    >
      {domainLetter(url)}
    </span>
  );
}
